import {FC} from 'react';
import {useParams} from 'react-router';

import CreateRateSheetForm from './components/createRateSheetForm';
import {CreateRateSheetProvider} from './providers/createRateSheetProvider';

/**
 * Create positions page
 * @returns {JSX.Element}
 */
const CreateRateSheetPage: FC = () => {
  const {rateSheetId} = useParams();

  // paths
  // 1. /distributor/rate-sheets/new
  // 2. /distributor/rate-sheets/:rateSheetId/edit
  // 3. /distributor/rate-sheets/:rateSheetId
  const mode = location.pathname.includes('new') ? 'create' : location.pathname.includes('edit') ? 'edit' : 'view';

  return (
    <CreateRateSheetProvider rateSheetId={rateSheetId} mode={mode}>
      <CreateRateSheetForm />
    </CreateRateSheetProvider>
  );
};

export default CreateRateSheetPage;
